import create from 'zustand'

const useStore = create(set => ({
  update: payload => set(() => ({ ...payload }))
}))

export default useStore
